import React from 'react';
import { BasePage } from '@sm/webassets';
import { useLocation } from 'react-router-dom';
import SEO from '~pricing/components/SEO';
import useScript from '~pricing/hooks/useScripts';
import { EXTERNAL_SCRIPTS } from '~pricing/lib/constants';
import useMainStyles from './useStyles';

export default function Layout({ children }: { children: React.ReactElement }): JSX.Element {
  useScript(EXTERNAL_SCRIPTS);
  // GP-69 Needs full page width so having the 1400px max-width from Main breaks the ui
  const routerLocation = useLocation();
  const { Main } = useMainStyles();
  return (
    <BasePage pageId="Pricing" legacyWeb="billweb" sticky={false}>
      <SEO>
        <main className={routerLocation.pathname !== '/pricing' ? Main : ''}>{children}</main>
      </SEO>
    </BasePage>
  );
}
